import React from 'react';
import { useTranslation } from 'react-i18next';
import './ServiceBadges.css';

interface Badge {
    icon: string;
    titleKey: string;
    descKey: string;
}

interface ServiceBadgesProps {
    badges?: Badge[];
}

const defaultBadges: Badge[] = [
    { icon: '✈️', titleKey: 'services.on_time_delivery', descKey: 'services.on_time_delivery_desc' },
    { icon: '🥗', titleKey: 'services.special_meals', descKey: 'services.special_meals_desc' },
    { icon: '🧪', titleKey: 'services.haccp_iso', descKey: 'services.haccp_iso_desc' },
    { icon: '🌍', titleKey: 'services.global_menus', descKey: 'services.global_menus_desc' },
];

const ServiceBadges: React.FC<ServiceBadgesProps> = ({ badges = defaultBadges }) => {
    const { t } = useTranslation();

    return (
        <section className="service-badges" aria-label="Service benefits">
            {badges.map((b, i) => (
                <div key={i} className="badge">
                    <div className="icon" aria-hidden>{b.icon}</div>
                    <div className="text">
                        <h4>{t(b.titleKey)}</h4>
                        <p>{t(b.descKey)}</p>
                    </div>
                </div>
            ))}
        </section>
    );
};

export default ServiceBadges;
